<template>
  <div class="prova-content">
    <button @click="confirmarVoltar" class="btn-voltar">Voltar</button>

    <!-- Modal de Confirmação para Voltar -->
    <div v-if="mostrarModalVoltar" class="modal-backdrop">
      <div class="modal-content">
        <img src="https://site-inove-bd2fd-homol.web.app/assets/icons/warning.svg" alt="alerta img" width="87px"
          height="81px" class="">
        <h3 style="font-size: 32px;">Tem certeza que deseja <br> <strong>sair desta página?</strong></h3>
        <p style="font-size: 16px; font-weight: bold; color: #4E4B59;">É importante saber que o tempo continuará sendo
          contabilizado mesmo ao sair desta página.</p>
        <div class="modal-buttons">
          <button @click="fecharModalVoltar"
            style="font-weight: bold; padding-inline: 20px; margin-right: 10px;">Cancelar</button>
          <button @click="voltarParaHome" style="font-weight: bold;">Sim, desejo sair da página</button>
        </div>
      </div>
    </div>

    <div class="status">
      <div class="tentativas">
        <img src="https://site-inove-bd2fd-homol.web.app/assets/icons/pause-test.svg" alt="pausar">
        <button class="pause" @click="togglePause" :disabled="isReviewMode">
          {{ isPaused ? "Retomar Avaliação" : "Pausar Avaliação" }}
        </button>
        <img src="https://site-inove-bd2fd-homol.web.app/assets/icons/attempts.svg" alt="tentativas">
        <span>Você possui {{ tentativas }}/{{ maxTentativas }} tentativas</span>
      </div>
      <div class="questoes">
        <span>Questões</span>
        <a v-for="(questao, index) in questoes" :key="index" :href="'#questao-' + index" :style="{
          backgroundColor: isReviewMode
            ? (questao.respostaSelecionada === questao.respostaCorreta
              ? '#16f9b9' // Verde para correta
              : (questao.respostaSelecionada ? '#f76868' : '#d9d9d9')) // Vermelho para incorreta, cinza para não respondida
            : (questao.respostaSelecionada ? '#16f9b9' : '#d9d9d9') // Verde para respondida, cinza para não respondida fora do modo de revisão
        }">
          {{ index + 1 }}
        </a>
      </div>
    </div>

    <div v-for="(questao, index) in questoes" :key="index" class="card-prova" :id="'questao-' + index">
      <div class="questions-bar">
        <div class="question-bar" v-for="(questaoBar, n) in questoes" :key="n" :style="{
          backgroundColor: isReviewMode
            ? (questaoBar.respostaSelecionada === questaoBar.respostaCorreta
              ? '#16f9b9' // Verde para correta
              : (questaoBar.respostaSelecionada ? '#f76868' : '#d9d9d9')) // Vermelho para incorreta, cinza para não respondida
            : (questaoBar.respostaSelecionada ? '#16f9b9' : '#d9d9d9') // Verde para respondidas, cinza para não respondidas fora do modo de revisão
        }">
        </div>
      </div>
      <h4>Teste final: {{ index + 1 }} / {{ questoes.length }}</h4>
      <p>{{ questao.pergunta }}</p>

      <div class="inputs-respostas">
        <form>
          <div v-for="(resposta, i) in questao.respostas" :key="i" class="inputs-form-group">
            <input type="radio" :name="'resposta-' + index" :id="'resp' + index + '-' + i" :value="resposta"
              v-model="questao.respostaSelecionada" :disabled="isPaused || isReviewMode">
            <label :for="'resp' + index + '-' + i">
              {{ resposta }}
              <span v-if="isReviewMode">
                <span v-if="resposta === questao.respostaCorreta">✅</span>
                <span v-else-if="resposta === questao.respostaSelecionada">❌</span>
              </span>
            </label>
            <br>
          </div>
        </form>
      </div>
    </div>

    <div class="w-100 d-flex justify-content-center mt-5 mb-3 finalizar">
      <button v-if="!isReviewMode" @click="abrirModal" :disabled="isPaused">
        <img src="https://site-inove-bd2fd-homol.web.app/assets/icons/warning-outline.svg" alt="icone">
        <span>FINALIZAR AVALIAÇÃO</span>
      </button>
      <button v-else @click="tentarNovamente">
        <span>TENTAR NOVAMENTE</span>
      </button>
    </div>

    <!-- Modal de confirmação -->
    <div v-if="exibirModal" class="modal-backdrop">
      <div class="modal-content">
        <button @click="fecharModal" style="background: none; border: none;">
          <img
            src="data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23000'><path d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/></svg>"
            width="21px" height="21px" style="position: absolute;     right: 24px;
    top: 20px;" alt="">
        </button>
        <img src="https://site-inove-bd2fd-homol.web.app/assets/icons/warning.svg" width="87px" height="86px"
          alt="Icone alerta">
        <h3 style="font-size: 32px; color: #212236;">Tem certeza que deseja <br><strong>finalizar a sua
            avaliação?</strong></h3>
        <p>Você respondeu {{ totalRespondidas }} de {{ questoes.length }} questões.</p>
        <div class="modal-buttons">
          <button @click="finalizarAvaliacao" style="font-size: 16px; color: #000;"><strong>Sim, desejo finalizar minha
              avaliação</strong></button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    timer: Number, // Tempo restante recebido do App.vue
    isPaused: Boolean, // Estado do timer (pausado ou ativo) recebido do App.vue
    isReviewMode: {
      type: Boolean,
      default: false, // Por padrão, o modo de revisão é falso
    },
    tentativas: {
      type: Number,
      required: true,
    },
    maxTentativas: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      questoes: [
        { pergunta: "Conforme o Código Civil, quem são absolutamente incapazes de exercer pessoalmente os atos da vida civil?", respostas: ["Os menores de 16 anos", "Todos os estrangeiros", "As pessoas com mais de 18 anos e sem profissão", "Os maiores de 16 e menores de 18 anos"], respostaCorreta: "Os menores de 16 anos", respostaSelecionada: "" },
        { pergunta: "Segundo a Constituição Federal de 1988, como o povo exerce seu poder?", respostas: ["Por meio de grupos armados", "Através de plebiscitos apenas", "Por meio de representantes eleitos ou diretamente", "Apenas por meio de autoridades militares"], respostaCorreta: "Por meio de representantes eleitos ou diretamente", respostaSelecionada: "" },
        { pergunta: "Qual é um dos fundamentos da República Federativa do Brasil?", respostas: ["O individualismo", "A desigualdade", "A soberania", "O militarismo"], respostaCorreta: "A soberania", respostaSelecionada: "" },
        { pergunta: "Em quais situações o voto é considerado facultativo?", respostas: ["Para todos os cidadãos maiores de 21 anos", "Para analfabetos, maiores de 70 anos e pessoas entre 16 e 18 anos", "Apenas para estrangeiros residentes", "Para cidadãos em serviço militar obrigatório"], respostaCorreta: "Para analfabetos, maiores de 70 anos e pessoas entre 16 e 18 anos", respostaSelecionada: "" },
        { pergunta: "De acordo com o artigo 2º da LGPD, um dos fundamentos da proteção de dados pessoais é:", respostas: ["O aumento do controle estatal sobre as informações pessoais", "O respeito à privacidade", "A obrigatoriedade de compartilhamento de dados entre empresas privadas", "A centralização das informações em um banco de dados único"], respostaCorreta: "O respeito à privacidade", respostaSelecionada: "" },
        { pergunta: "Qual é a base de cálculo do imposto sobre a propriedade territorial rural?", respostas: ["O valor venal do imóvel", "O valor fundiário do imóvel", "O preço de mercado do imóvel", "O rendimento agrícola do imóvel"], respostaCorreta: "O valor fundiário do imóvel", respostaSelecionada: "" },
        { pergunta: "As horas suplementares no regime de tempo parcial podem ser realizadas quando a jornada semanal for de:", respostas: ["Até 44 horas", "Até 30 horas", "Até 26 horas, com acréscimo de até 6 horas suplementares", "Até 20 horas"], respostaCorreta: "Até 26 horas, com acréscimo de até 6 horas suplementares", respostaSelecionada: "" },
        { pergunta: "O imposto sobre transmissão de bens imóveis não incide quando:", respostas: ["A transmissão é feita para a incorporação de bens ao patrimônio de uma pessoa jurídica", "A pessoa jurídica tem atividade preponderante de locação de imóveis", "A transmissão é feita por ato gratuito entre familiares", "O imóvel transmitido está localizado fora do Brasil"], respostaCorreta: "A transmissão é feita para a incorporação de bens ao patrimônio de uma pessoa jurídica", respostaSelecionada: "" },
        { pergunta: "O Poder Executivo pode alterar as alíquotas dos impostos de importação e exportação para:", respostas: ["Aumentar a arrecadação tributária geral", "Ajustá-las à política cambial e de comércio exterior", "Punir práticas de concorrência desleal no mercado interno", "Atender demandas específicas dos consumidores"], respostaCorreta: "Ajustá-las à política cambial e de comércio exterior", respostaSelecionada: "" },
        { pergunta: "O salário de empregados em regime de tempo parcial deve ser:", respostas: ["Igual ao dos empregados em regime integral, independentemente da jornada", "Proporcional à jornada cumprida em relação ao regime integral", "Fixo, de acordo com o acordo coletivo, sem considerar a jornada", "Superior ao salário dos empregados em regime integral"], respostaCorreta: "Proporcional à jornada cumprida em relação ao regime integral", respostaSelecionada: "" },
      ],
      exibirModal: false,
      mostrarModalVoltar: false,
    };
  },
  computed: {
    //Calcula quantas questões foram respondidas
    totalRespondidas() {
      return this.questoes.filter(questao => questao.respostaSelecionada).length;
    },
  },
  methods: {
    atualizarQuestaoSelecionada(index) {
      //Garantir que a resposta da questão seja registrada
      if (!this.questoes[index].respostaSelecionada) {
        this.questoes[index].respostaSelecionada = ''; //Inicializa a resposta se ainda não houver
      }
    },
    abrirModal() {
      this.exibirModal = true;
    },
    fecharModal() {
      this.exibirModal = false;
    },
    finalizarAvaliacao() {
      // Captura os horários de início e término
      const inicio = sessionStorage.getItem("inicioProva") || new Date().toISOString();
      const fim = new Date().toISOString();

      // Formata os horários
      const formatarDataHora = (dataHora) => {
        const data = new Date(dataHora);
        const dia = String(data.getDate()).padStart(2, "0");
        const mes = String(data.getMonth() + 1).padStart(2, "0");
        const ano = data.getFullYear();
        const horas = String(data.getHours()).padStart(2, "0");
        const minutos = String(data.getMinutes()).padStart(2, "0");
        return `${dia}/${mes}/${ano} às ${horas}h${minutos}`;
      };

      const inicioFormatado = formatarDataHora(inicio);
      const fimFormatado = formatarDataHora(fim);

      // Captura os dados da avaliação
      const totalQuestoes = this.questoes.length;
      const totalAcertos = this.questoes.filter(
        (questao) => questao.respostaSelecionada === questao.respostaCorreta
      ).length;

      // Salva os dados no sessionStorage
      sessionStorage.setItem(
        "resultadoProva",
        JSON.stringify({
          inicio: inicioFormatado,
          fim: fimFormatado,
          totalQuestoes,
          totalAcertos,
        })
      );

      // Pausa o timer no App.vue
      this.$emit("pause-timer");

      // Navega para a página finalizado
      this.$parent.currentPage = "finalizado";
      sessionStorage.setItem("currentPage", "finalizado");

    },
    togglePause() {
      this.$emit("toggle-pause");
    },
    confirmarVoltar() {
      this.mostrarModalVoltar = true;
    },
    fecharModalVoltar() {
      this.mostrarModalVoltar = false;
    },
    voltarParaHome() {
      this.$parent.currentPage = "home";
      sessionStorage.setItem("currentPage", "home");
    },
    tentarNovamente() {
      if (this.tentativas < this.maxTentativas) {
        sessionStorage.removeItem("timer");
        sessionStorage.removeItem("respostasSelecionadas");
        sessionStorage.removeItem("resultadoProva");
        this.$emit("reset-timer");
        window.location.reload();
      } else {
        alert("Você já atingiu o limite máximo de tentativas.");
      }
    },
  },
  mounted() {
    if (this.isReviewMode) {
      const respostasSelecionadas = JSON.parse(sessionStorage.getItem("respostasSelecionadas")) || [];
      this.questoes.forEach((questao, index) => {
        questao.respostaSelecionada = respostasSelecionadas[index] || ""; // Restaura as respostas
      });
    }
  }
};
</script>

<style scoped>
html {
  scroll-behavior: smooth;
}

.prova-content {
  position: relative;
}

.btn-voltar {
  position: absolute;
  padding: 8px;
  padding-inline: 15px;
  border: none;
  border-radius: 8px;
  background-color: #16f9b9;
  color: #212236;
  top: -50px;
}

.btn-voltar:hover {
  background: #69f9de;
}

.status {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pause {
  background: #ed9090;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  padding: 5px;
  padding-inline: 15px;
  color: #212236;
  margin-inline: 15px;
}

.pause:hover {
  background: #f18080;
}

.tentativas {
  display: flex;
  align-items: center;
}

.tentativas span {
  margin-left: 10px;
}

.questoes {
  display: flex;
  align-items: center;
}

.questoes a {
  text-decoration: none;
  display: flex;
  width: 28px;
  height: 29px;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  border: 1px solid #212236;
  color: #212236;
  margin: 3px;
  font-size: 14px;
  letter-spacing: -.14px;
}

.card-prova {
  padding: 34px 24px;
  border-radius: 8px;
  background: #fff;
  width: 100%;
  margin-top: 3%;
}

.questions-bar {
  display: flex;
}

.question-bar {
  width: 100%;
  height: 8px;
  background-color: #d9d9d9;
  margin-right: 10px
}

.card-prova h4 {
  font-size: 24px;
  font-weight: bold;
  margin-top: 2%;
}

.card-prova p {
  font-size: 20px;
  font-weight: bold;
  margin-top: 2%;
}

.inputs-form-group {
  display: flex;
  align-items: center;
  margin-top: 2%;
}

.inputs-respostas form label {
  margin-left: 10px;
  font-size: 16px;
}

input[type=radio] {
  width: 30px;
  height: 30px;
  min-width: 30px;
  min-height: 30px;
  border-radius: 50%;
  background: #fff;
  background: transparent;
  border: 1px solid #8c8a97;
}

.finalizar button {
  background: #5df1c7;
  color: #212236;
  font-weight: bold;
  font-size: 20px;
  border-radius: 8px;
  border: none;
  padding: 15px;
  display: flex;
  align-items: center;
}

.finalizar button:hover {
  background: #69f9de;
}

.finalizar button span {
  margin-left: 5px;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  position: relative;
  width: 498px;
  height: 374px;
  background: white;
  padding: 20px;
  border-radius: 8px;
  text-align: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-buttons {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
}

.modal-buttons button {
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}

.modal-buttons button:first-child {
  background: #ed9090;
  color: white;
}

.modal-buttons button:last-child {
  background: #16f9b9;
}

.modal-buttons button:last-child:hover {
  background: #69f9de;
}

input:disabled {
  cursor: not-allowed;
  background-color: #f0f0f0;
  color: #aaa;
}

button:disabled {
  cursor: not-allowed;
  background-color: #d3d3d3;
  /* Cor cinza para indicar desabilitado */
  color: #aaa;
  /* Cor mais clara no texto */
}

button:disabled:hover {
  background-color: #d3d3d3;
}

@media(max-width:768px) {
  .status {
    display: block;
  }

  .questoes {
    margin-top: 4%;
  }

  .status img {
    display: none;
  }

  .question-bar {
    margin-right: 3px;
  }

  .card-prova h4 {
    font-size: 19px;
    margin-top: 10px;
  }

  .card-prova p {
    font-size: 17.5px;
  }

  .inputs-respostas form label {
    font-size: 14px;
  }

  .finalizar {
    margin-bottom: 12% !important;
  }

  .modal-content {
    width: 370px;
  }

  .modal-content h3 {
    font-size: 20px !important;
  }

}
</style>